import React from 'react';
import { deviceMetricsShorten } from '../../../../constants/deviceMetrics';
import { formatDelta } from '../../../../utils/delta';
import { deviceMetricsColors, comparedTextToPeriod } from '../../../../constants/deviceMetrics';
import DeltaIconDown from '../../Icons/DeltaIconDown';
import DeltaIconUp from '../../Icons/DeltaIconUp';
import DeltaIconNeutral from '../../Icons/DeltaIconNeutral';

const Metric = ({ value, property }) => {
  const deltaFormatted = formatDelta(value?.delta, 2);
  const color = deviceMetricsColors[property] || '#0f172a';

  return (
    <div className="flex flex-col gap-1.5 text-xs sm:text-sm min-w-0">
      <div className="text-slate-700 dark:text-slate-300 font-medium truncate">
        {deviceMetricsShorten[property] ?? property}:
      </div>

      <div className="flex items-center gap-2 min-w-0">
        <span className="text-slate-900 dark:text-slate-100 whitespace-nowrap">
          {value?.formatted}
        </span>

        {deltaFormatted?.formatted && (
          <div className="flex items-center gap-1.5 min-w-0">
            {deltaFormatted.sign === 'neutral' ? (
              <DeltaIconNeutral color={color} />
            ) : deltaFormatted.sign === 'positive' ? (
              <DeltaIconUp color={color} />
            ) : (
              <DeltaIconDown color={color} />
            )}
            <p className="text-xs sm:text-sm truncate" style={{ color }}>
              {deltaFormatted.formatted} {comparedTextToPeriod[property]}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(Metric);
